import { createFileRoute } from '@tanstack/react-router'

import { BookingDetail } from '@/features/bookings/booking-detail'

export const Route = createFileRoute('/_app/bookings/$bookingId')({
  component: BookingDetail,
})
